import { getDefaultExportFromCjs as n } from "./index.es69.js";
import { _ as a } from "./index.es79.js";
var l = a;
function f(t) {
  var e = t == null ? 0 : t.length;
  return e ? l(t, 1) : [];
}
var o = f;
const m = /* @__PURE__ */ n(o);
export {
  m as default,
  o as f
};
//# sourceMappingURL=index.es30.js.map
